/**
 * Created by mac on 5/6/17.
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    PATH_COLOR: new cc.Color(85, 244, 82, 255),
    LETTER: new cc.Color(80, 60, 35, 255),
    COLOR_VICTORY: new cc.Color(240, 73, 0, 255),
    GREEN_YELLOW: new cc.Color(145, 255, 78, 255),
    PLAYER_ALARM_COLOR: new cc.Color(150, 150, 150, 255),
    COLOR_BROWN: new cc.Color(130, 70, 40, 255)
});

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    CONGRATE_STROKE: {
        color: cleverapps.styles.COLORS.GREEN,
        size: 4
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LETTERS_TEXT: {
        size: 80,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    EXTRA_WINDOW_TITLE_TEXT: {
        size: 70,
        color: new cc.Color(245, 132, 46, 255),
        stroke: {
            size: 2,
            color: new cc.Color(63, 47, 25, 255)
        },
        shadow: {
            color: new cc.Color(63, 47, 25, 255),
            direction: cc.size(0, -2),
            blur: 1
        }
    },

    BOARD_TEXT: {
        size: 80,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    REWARDS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    PACKWINDOW_LABEL_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    LOADING_ANIMATION_TEXT: {
        size: 40,
        color: new cc.Color(0, 0, 70, 255)
    },

    CURRENT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

FingerView.PATH_BASE_ALPHA = 100;
FingerView.PATH_LINE_WIDTH = 20;

cleverapps.overrideStyles(cleverapps.styles.Tabs, {
    margin: -10
});

cleverapps.overrideStyles(cleverapps.styles.Buttons, {
    margin: {
        x: 20
    }
});

cleverapps.overrideStyles(cleverapps.styles.ShuffleButton, {
    y: { align: "bottom", dy: -50 }
});

cleverapps.overrideStyles(cleverapps.styles.HintButtonBooster, {
    mirrorArrowY: true,
    zOrder: 1,
    arrowOffsetY: 34,

    scale: [0.8, 1, 1],

    width: 150,
    height: 120,
    content: {
        margin: -10,
        direction: cleverapps.UI.VERTICAL,
        layout: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 15 }
        }
    },

    position: [
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 16 } },
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 510 } },
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 510 } }
    ]
});

cleverapps.overrideStyles(cleverapps.styles.KingsCupMarksView, {
    width: 180,
    height: 70,

    icon: {
        x: { align: "left", dx: -20 }
    },

    text: {
        y: { align: "center", dy: 2 }
    },

    position: [
        {
            x: { align: "left", dx: 20 },
            y: { align: "center", dy: 0 }
        },
        {
            x: { align: "left", dx: 20 },
            y: { align: "center", dy: 0 }
        },
        {
            x: { align: "left", dx: 20 },
            y: { align: "center", dy: 0 }
        }
    ]
});

if (cleverapps.styles.LightningRushMarksView) {
    cleverapps.overrideStyles(cleverapps.styles.LightningRushMarksView, {
        width: 180,
        height: 70,

        icon: {
            x: { align: "left", dx: -20 }
        },

        text: {
            y: { align: "center", dy: 2 }
        },

        position: [
            {
                x: { align: "left", dx: 20 },
                y: { align: "center", dy: 0 }
            },
            {
                x: { align: "left", dx: 20 },
                y: { align: "center", dy: 0 }
            },
            {
                x: { align: "left", dx: 20 },
                y: { align: "center", dy: 0 }
            }
        ]
    });
}

cleverapps.overrideStyles(cleverapps.styles.GameScene, {
    sound: {
        delay: 2.3
    }
});

cleverapps.styles.xmasNewStyles = {
    heroTitleAnimation: {
        x: { align: "left", dx: -50 },
        y: { align: "top", dy: 270 },
        scale: 0.8
    }
};

cleverapps.overrideStyles(cleverapps.styles.CookieJarView, {
    scale: 0.5,
    prizeFlyPositionShift: {
        x: -50,
        y: -170
    }
});

cleverapps.overrideStyles(cleverapps.styles.CharView, {
    topPaddingWithBg: -8
});

cleverapps.overrideStyles(cleverapps.styles.LoadingAnimation, {
    text: false
});
